module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('el-row', {
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("商品分类管理")])]), _vm._v(" "), _c('p', {
    staticClass: "goodslist1",
    staticStyle: {
      "padding": "0 0 10px 10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.addOrEditClassification
    }
  }, [_vm._v("新增分类")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addOrEditClassification('editRow')
      }
    }
  }, [_vm._v("编辑分类")])], 1), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    staticStyle: {
      "padding": "0px 12px"
    }
  }, [_c('el-tree', {
    staticClass: "lineheighttree",
    attrs: {
      "data": _vm.treeData,
      "props": _vm.defaultProps,
      "accordion": ""
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1)])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_c('span', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v(_vm._s(_vm.commodityParameters))]), _vm._v(" 品类关联的品牌及商品参数")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 0 10px 20px"
    }
  }, [(_vm.endChildren) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addRelatedBrand()
      }
    }
  }, [_vm._v("新增关联品牌")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.seeCategoryOperationRecord()
      }
    }
  }, [_vm._v("查看当前品类操作记录")]), _vm._v(" "), (_vm.endParameter) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.endManageProductParameters()
      }
    }
  }, [_vm._v("管理商品参数")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container",
    staticStyle: {
      "padding": "0 10px"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.Id,
            "label": scope.row.Id
          }
        }, [_vm._v(_vm._s(scope.row.Id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关联的品牌",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.Name,
            "label": scope.row.Name
          }
        }, [_vm._v(_vm._s(scope.row.Name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "编辑",
      "fixed": "right",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "action_container",
          on: {
            "click": function($event) {
              return _vm.deleteBrand(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "add_order_cancle",
    attrs: {
      "title": "品类管理",
      "center": true,
      "width": "30%",
      "visible": _vm.isToExamine
    },
    on: {
      "update:visible": function($event) {
        _vm.isToExamine = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "所属一级分类:",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "disabled": _vm.classAdisabled,
      "placeholder": "请选择",
      "filterable": ""
    },
    on: {
      "change": _vm.selectChanged
    },
    model: {
      value: (_vm.classAclassification),
      callback: function($$v) {
        _vm.classAclassification = $$v
      },
      expression: "classAclassification"
    }
  }, _vm._l((_vm.classAclassificationArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类名称:",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "maxlength": "20",
      "placeholder": "请输入分类名称 (20字以内)"
    },
    model: {
      value: (_vm.brandName),
      callback: function($$v) {
        _vm.brandName = $$v
      },
      expression: "brandName"
    }
  })], 1), _vm._v(" "), (_vm.showLogo) ? _c('el-form-item', {
    attrs: {
      "label": "分类Logo:",
      "label-width": "100px"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "accept": ".png, .jpg",
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.Thumbnail) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.Thumbnail
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "src": require("../../assets/img/aicon15_09.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("尺寸必须为90px*36px，支持png、jpg格式")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default cancle normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isToExamine = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default search_btn normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit()
      }
    }
  }, [_vm._v("保存")])])], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "visible": _vm.dialogTable,
      "before-close": _vm.cancelForm,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTable = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('ul', {
          staticClass: "drawer_title"
        }, [_c('li', [_vm._v(_vm._s(_vm.record))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger"
          },
          on: {
            "click": _vm.cancelForm
          }
        }, [_vm._v("关 闭")])], 1)]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "drawer_div"
  }, [_c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.gridData,
      "height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "OperationDes",
      "label": "操作类型",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "OperatorName",
      "label": "操作人",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "CTime",
      "label": "操作时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('template', {
    slot: "append"
  }, [_c('div', {
    staticClass: "scrollingTips"
  }, [(_vm.loading) ? _c('p', [_vm._v("正在加载")]) : _vm._e(), _vm._v(" "), (_vm.noMore) ? _c('p', [_vm._v("没有更多了")]) : _vm._e()])])], 2)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "add_order_cancle",
    attrs: {
      "title": "关联品牌",
      "center": true,
      "width": "26%",
      "visible": _vm.vRelatedBrands
    },
    on: {
      "update:visible": function($event) {
        _vm.vRelatedBrands = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "所属品牌:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "66%"
    },
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.modelBrandId),
      callback: function($$v) {
        _vm.modelBrandId = $$v
      },
      expression: "modelBrandId"
    }
  }, _vm._l((_vm.brandArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default cancle normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.vRelatedBrands = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default search_btn normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editBrand()
      }
    }
  }, [_vm._v("保存")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "管理商品参数",
      "center": true,
      "width": "35%",
      "visible": _vm.vCommodityParameters
    },
    on: {
      "update:visible": function($event) {
        _vm.vCommodityParameters = $event
      }
    }
  }, [_c('div', {
    staticClass: "formLabel"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.propTableData.col,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "align": "center",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "参数名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isSet) ? _c('span', [_c('el-input', {
          attrs: {
            "size": "mini",
            "maxlength": "6"
          },
          model: {
            value: (scope.row.Name),
            callback: function($$v) {
              _vm.$set(scope.row, "Name", $$v)
            },
            expression: "scope.row.Name"
          }
        })], 1) : _c('span', [_vm._v(_vm._s(scope.row.Name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "170px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isSet) ? [_c('el-button', {
          staticStyle: {
            "margin": "6px 3px"
          },
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.valChange(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin": "6px 3px"
          },
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.row, scope.$index)
            }
          }
        }, [_vm._v("删除")])] : [_c('el-button', {
          staticStyle: {
            "margin": "6px 3px"
          },
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.paramSave(scope.row)
            }
          }
        }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin": "6px 3px"
          },
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.cancelAddOrEdit(scope.row)
            }
          }
        }, [_vm._v("取消")])]]
      }
    }])
  }, [_c('template', {
    slot: "header"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footParameterPopup"
  }, [_c('button', {
    staticClass: "el-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.vCommodityParameters = false
      }
    }
  }, [_vm._v("取消")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06c2329e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/categoryManagement.vue
// module id = 1624
// module chunks = 3